var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "card", attrs: { "data-user-rank": "" } }, [
    _c(
      "h5",
      {
        staticClass:
          "card-header d-flex justify-content-between align-items-center"
      },
      [
        _vm._v(
          " " +
            _vm._s(
              _vm.isIndex
                ? _vm.ui.formatString(_vm.T.userRankOfTheMonthHeader, {
                    count: _vm.length
                  })
                : _vm.ui.formatString(_vm.T.rankRangeHeader, {
                    lowCount: (_vm.page - 1) * _vm.length + 1,
                    highCount: _vm.page * _vm.length
                  })
            ) +
            " "
        ),
        _c(
          "a",
          { attrs: { href: _vm.UserRankingFeatureGuideURL } },
          [
            _c("font-awesome-icon", {
              attrs: { icon: ["fas", "question-circle"] }
            }),
            _vm._v(" " + _vm._s(_vm.T.wordsRankingMeasurement))
          ],
          1
        )
      ]
    ),
    !_vm.isIndex
      ? _c(
          "div",
          { staticClass: "card-body form-row" },
          [
            _c("omegaup-common-typeahead", {
              staticClass: "col col-md-3 pl-0 pr-2",
              attrs: {
                "existing-options": _vm.searchResultUsers,
                value: _vm.searchedUsername,
                "max-results": 10
              },
              on: {
                "update:value": function($event) {
                  _vm.searchedUsername = $event
                },
                "update-existing-options": function(query) {
                  return _vm.$emit("update-search-result-users", query)
                }
              }
            }),
            _c(
              "button",
              {
                staticClass:
                  "btn btn-primary form-control col-4 col-md-2 mr-0 mr-md-2",
                attrs: { type: "button" },
                on: { click: _vm.onSubmit }
              },
              [_vm._v(" " + _vm._s(_vm.T.searchUser) + " ")]
            ),
            Object.keys(_vm.availableFilters).length > 0
              ? [
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.currentFilter,
                          expression: "currentFilter"
                        }
                      ],
                      staticClass:
                        "filter form-control col-12 col-md-5 mt-2 mt-md-0",
                      on: {
                        change: function($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function(o) {
                              return o.selected
                            })
                            .map(function(o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.currentFilter = $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        }
                      }
                    },
                    [
                      _c("option", { attrs: { value: "" } }, [
                        _vm._v(" " + _vm._s(_vm.T.wordsSelectFilter) + " ")
                      ]),
                      _vm._l(_vm.availableFilters, function(item, key, index) {
                        return _c(
                          "option",
                          { key: index, domProps: { value: key } },
                          [_vm._v(" " + _vm._s(item) + " ")]
                        )
                      })
                    ],
                    2
                  )
                ]
              : !_vm.isLogged && !_vm.isIndex
              ? [
                  _c(
                    "span",
                    {
                      staticClass:
                        "badge badge-info text-wrap p-2 mt-2 mt-lg-0 d-flex align-items-center"
                    },
                    [_vm._v(_vm._s(_vm.T.mustLoginToFilterUsers))]
                  )
                ]
              : !_vm.isIndex
              ? [
                  _c(
                    "span",
                    {
                      staticClass:
                        "badge badge-info text-wrap p-2 mt-2 mt-lg-0 d-flex align-items-center"
                    },
                    [_vm._v(_vm._s(_vm.T.mustUpdateBasicInfoToFilterUsers))]
                  )
                ]
              : _vm._e()
          ],
          2
        )
      : _vm._e(),
    _vm.ranking.length === 0
      ? _c("div", { staticClass: "empty-category text-center m-4" }, [
          _c("h2", [_vm._v(_vm._s(_vm.T.userRankEmptyList))])
        ])
      : _c("div", [
          _c("p", { staticClass: "text-right mr-3 mb-2 text-muted" }, [
            _vm._v(_vm._s(_vm.lastUpdatedText))
          ]),
          _c("table", { staticClass: "table mb-0 table-responsive-sm" }, [
            _c("thead", [
              _c("tr", [
                _c(
                  "th",
                  {
                    staticClass: "pl-4 column-width align-middle",
                    attrs: { scope: "col" }
                  },
                  [_vm._v("#")]
                ),
                _c(
                  "th",
                  { staticClass: "align-middle", attrs: { scope: "col" } },
                  [_vm._v(_vm._s(_vm.T.contestParticipant))]
                ),
                _c(
                  "th",
                  {
                    staticClass: "text-right align-middle",
                    attrs: { scope: "col" }
                  },
                  [_vm._v(" " + _vm._s(_vm.T.rankScore) + " ")]
                ),
                !_vm.isIndex
                  ? _c(
                      "th",
                      {
                        staticClass: "text-right pr-4 align-middle",
                        attrs: { scope: "col" }
                      },
                      [
                        _vm._v(" " + _vm._s(_vm.T.rankSolved) + " "),
                        _c(
                          "b-button",
                          {
                            staticClass: "ml-1",
                            attrs: {
                              id: "popover-solved-problems",
                              size: "sm",
                              variant: "none"
                            },
                            on: {
                              click: function($event) {
                                _vm.showPopover = !_vm.showPopover
                              }
                            }
                          },
                          [
                            _c("font-awesome-icon", {
                              attrs: { icon: ["fas", "question-circle"] }
                            })
                          ],
                          1
                        ),
                        _c(
                          "b-popover",
                          {
                            attrs: {
                              show: _vm.showPopover,
                              target: "popover-solved-problems",
                              placement: "right"
                            },
                            on: {
                              "update:show": function($event) {
                                _vm.showPopover = $event
                              }
                            }
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.T.userRankSolvedProblemsHelp) +
                                " "
                            )
                          ]
                        )
                      ],
                      1
                    )
                  : _vm._e()
              ])
            ]),
            _c(
              "tbody",
              _vm._l(_vm.ranking, function(user, index) {
                return _c("tr", { key: index }, [
                  _c(
                    "th",
                    {
                      staticClass: "pl-4 column-width",
                      attrs: { scope: "row" }
                    },
                    [_vm._v(_vm._s(user.rank))]
                  ),
                  _c(
                    "td",
                    [
                      _c("omegaup-countryflag", {
                        attrs: { country: user.country }
                      }),
                      _c("omegaup-user-username", {
                        attrs: {
                          classname: user.classname,
                          linkify: true,
                          username: user.username
                        }
                      }),
                      user.name && _vm.length !== 5
                        ? _c("span", [
                            _c("br"),
                            _vm._v(" " + _vm._s(user.name))
                          ])
                        : _vm._e()
                    ],
                    1
                  ),
                  _c("td", { staticClass: "text-right" }, [
                    _vm._v(_vm._s(user.score.toFixed(2)))
                  ]),
                  !_vm.isIndex
                    ? _c("td", { staticClass: "text-right pr-4" }, [
                        _vm._v(" " + _vm._s(user.problems_solved) + " ")
                      ])
                    : _vm._e()
                ])
              }),
              0
            )
          ])
        ]),
    _vm.isIndex
      ? _c("div", { staticClass: "card-footer" }, [
          _c("a", { attrs: { href: "/rank/" } }, [
            _vm._v(_vm._s(_vm.T.wordsSeeGeneralRanking))
          ])
        ])
      : _c(
          "div",
          { staticClass: "card-footer" },
          [
            _c("omegaup-common-paginator", {
              attrs: { "pager-items": _vm.pagerItems }
            })
          ],
          1
        )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }